import lungs1 from 'url:../../../assets/images/lungs-ex-1.webp';
import lungs2 from 'url:../../../assets/images/lungs-ex-2.webp';

export const lungesHexRevealAssets = {
  lungs1,
  lungs2,
} as const;

export const lungesHexRevealAssetList = Object.values(lungesHexRevealAssets);
